app.controller('studentAssignmentCtrl',function($rootScope, $scope, $timeout, $http, $stateParams, $state){
  $scope.data = {
    assignment:null,
    questions:null,
    question:null,
    statusIcons:['icon-circle-blank','icon-circle','icon-ok correct','icon-remove wrong'],
    typeIcons:{SR:'icon-pencil',ER:'icon-pencil',MC:'icon-check',TF:'icon-check'},
    letters:'ABCDEFG'.split(''),
  };

  function cleanHTML(text){
    var tank = document.createElement("div");
    var spans;
    tank.innerHTML = text;
    spans = $(tank).find('span.MathJax_Preview');
    if(spans)spans.remove();
    spans = $(tank).find('span.MathJax_SVG');
    if(spans)spans.remove();
    spans = $(tank).find('script[type="math/mml"]');
    for(var i = 0; i < spans.length; i++){
      $(spans[i]).after(spans[i].innerHTML);
    }
    if(spans) spans.remove()
    return tank.innerHTML;
  }

  $scope.selectQuestion = function(index){
    $scope.data.questionIndex = index;
    $scope.data.question = $scope.data.questions[index];
    $scope.data.timer = Date.now();
  }

  $scope.saveQuestion = function(suppress){
    $scope.data.question.time += Date.now()-$scope.data.timer;
    $scope.data.question.status = ($scope.data.question.answer.idResponse||$scope.data.question.answer.answer || $scope.data.question.answer)?1:0;
    return $http({
     method: 'PUT',
     url: $rootScope.school.database+'/api/student/'+$rootScope.profile.idStudent+'/assignments/attempt/'+$scope.data.assignment.idStudentAssignment+'/response/'+$scope.data.question.idStudentResponse,
     headers: {
       Authorization: 'Bearer '+localStorage.getItem('studentToken'),
     },
     data: {
       time: $scope.data.question.time,
       status: $scope.data.question.status,
       fkResponse: $scope.data.question.answer.idResponse || null,
       responseText: cleanHTML($scope.data.question.answer.answer || $scope.data.question.answer),
     }
    })
    .then(function(){
      return $http({
        method: 'PUT',
        url: $rootScope.school.database+'/api/student/'+$rootScope.profile.idStudent+'/assignments/attempt/'+$scope.data.assignment.idStudentAssignment,
        headers: {
          Authorization: 'Bearer '+localStorage.getItem('studentToken'),
        },
        data: {}
     });
    })
    .then(function(){
      if(!suppress)alertify.success('Question Saved');
      $timeout(function() {
        $scope.$apply();
      })
    })
    .catch(function(err){
      console.log(err);
      alertify.error('An error occured, please check your internet connection and refresh your page. If you are still having problems, contact your teacher for assistance');
    });
  }

  $scope.submitExam = function(){
    $scope.saveQuestion(true)
    .then(function(){
      var unanswered = 0;
      for(var i = 0; i < $scope.data.questions.length; i++){
        if($scope.data.questions[i].status == 0)unanswered++;
      }
      var str = '';
      if(unanswered > 0){
        str += '<h5 class="alert alert-danger">You have '+unanswered+' incomplete question(s)</h5><br>';
      }
      str += 'Are you sure you wish to submit this assignment?';
      bootbox.confirm(str, function(result){
        if(result){
          return $http({
            method: 'PUT',
            url: $rootScope.school.database+'/api/student/'+$rootScope.profile.idStudent+'/assignments/attempt/'+$scope.data.assignment.idStudentAssignment+'/submit',
            headers: {
              Authorization: 'Bearer '+localStorage.getItem('studentToken'),
            },
            data: {}
          })
          .then(function(){
            $state.go('home');
          })
          .catch(function(err){
            console.log(err);
            alertify.error('An error occured, please check your internet connection and refresh your page. If you are still having problems, contact your teacher for assistance');
          });
        }
      });
    });
  }

  $rootScope.$watch('profile',function(profile){
    if(profile){

      var loop = setInterval(function () {
        if($rootScope.schools && !$rootScope.school){
          for(var i = 0; i < $rootScope.schools.length; i++){
            if($rootScope.schools[i].idSchool==profile.fkSchool)
              $rootScope.school = $rootScope.schools[i];
          }
        }
        if($rootScope.school){
          clearInterval(loop);
          $http({
             method: 'GET',
             url: $rootScope.school.database+'/api/student/'+$rootScope.profile.idStudent+'/assignments/attempt/'+$stateParams.id,
             headers: {
               Authorization: 'Bearer '+localStorage.getItem('studentToken'),
             }
           })
          .then(function(res){
            if(res && res.data && res.data.attempt && res.data.responses){
              $scope.data.assignment=res.data.attempt;
              $scope.data.questions=res.data.responses;
              $scope.data.passages=res.data.passages;
              for(var i = 0; i < $scope.data.questions.length; i++){
                if($scope.data.questions[i].fkPassage)
                  $scope.data.questions[i].passage = $scope.data.passages.find(function(p){return p.idPassage == $scope.data.questions[i].fkPassage;})
                if($scope.data.questions[i].responses)
                  $scope.data.questions[i].answer = $scope.data.questions[i].responses.find(function(r){return r.idResponse == $scope.data.questions[i].fkResponse});
                if(!$scope.data.questions[i].answer)
                  $scope.data.questions[i].answer = $scope.data.questions[i].responseText||'';
              }
              $scope.selectQuestion(0);
            } else {
              $state.go('home');
            }
          })
          .catch(function(err){
            $state.go('home');
          })
        }
      }, 100);
    }
  });
});
